import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const UsuarioPerfil = () => {
  const [usuario, setUsuario] = useState(null);
  const [formulario, setFormulario] = useState({});
  const [cargando, setCargando] = useState(true);

  const idUsuario = cookies.get("id"); // ID del usuario desde cookies

  useEffect(() => {
    if (idUsuario) {
      axios
        .get(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerUsuarioPorId?Id=${idUsuario}`,
        )
        .then((response) => {
          const datosUsuario = response.data[0];
          setUsuario(datosUsuario);
          setFormulario(datosUsuario);
          setCargando(false);
        })
        .catch((error) => {
          console.error("Error al obtener usuario:", error);
          Swal.fire(
            "Error",
            "No se pudo cargar la información del usuario",
            "error",
          );
        });
    }
  }, [idUsuario]);

  const handleChange = (e) => {
    setFormulario({ ...formulario, [e.target.name]: e.target.value });
  };

  const handleGuardar = () => {
    axios
      .put(
        `https://suadesarrollo.azurewebsites.net/api/ActualizarUsuarios?Id=${idUsuario}`,
        formulario,
      )
      .then(() => {
        Swal.fire(
          "Éxito",
          "Los datos fueron actualizados correctamente",
          "success",
        );
      })
      .catch(() => {
        Swal.fire("Error", "No se pudieron actualizar los datos", "error");
      });
  };

  if (cargando) return <p className="mt-3">Cargando datos del usuario...</p>;

  return (
    <div className="container mt-4">
      <h3>Perfil del Usuario</h3>
      <div className="form-group">
        <label>Nombre</label>
        <input
          className="form-control"
          type="text"
          name="nombre"
          value={formulario.nombre || ""}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Correo Electrónico</label>
        <input
          className="form-control"
          type="email"
          name="correo_Electronico"
          value={formulario.correo_Electronico || ""}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Contraseña</label>
        <input
          className="form-control"
          type="password"
          name="contrasena"
          value={formulario.contrasena || ""}
          onChange={handleChange}
        />
      </div>

      <button className="btn btn-primary mt-3" onClick={handleGuardar}>
        Guardar Cambios
      </button>
    </div>
  );
};

export default UsuarioPerfil;
